import React from "react";
import {
  Button,
  Dialog,
  DialogContent,
  Typography,
  Card,
  Box,
  useMediaQuery,
} from "@mui/material";
import { getGuidedModeSelectionStyle } from "../../../components/customstyles/GuidedModeSelectionScreenStyle";
import { getAssessmentWalkthroughStyle } from "../../../components/customstyles/AssessmentWalkthroughStyle";
import { useTheme } from "@emotion/react";
import { useGuidedMode } from "../../../providers/GuidedModeProvider";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

const useStyles = () => {
  const theme = useTheme();
  return {
    ...getAssessmentWalkthroughStyle(theme),
    guided: getGuidedModeSelectionStyle(theme),
  };
};

export default function GuidedModeSelectionScreen() {
  const styles = useStyles();
  const isMobile = useMediaQuery("(max-width: 900px)");
  const { showGuidedModeDialog, handleSwitchChange, showOrHideGuidedMode } =
    useGuidedMode();

  const guidedModeCards = [
    {
      title: "Guided Mode",
      description:
        "Perfect for those new to eAIMS. We'll guide you through each step with clear instructions and helpful tips.",
      btntext: "Start in Guided Mode",
      value: true,
    },
    {
      title: "Expert Mode",
      description:
        "For those already familiar with eAIMS. This version is optimized for quick completion with a streamlined interface.",
      btntext: "Start in Expert Mode",
      value: false,
    },
  ];
  return (
    <React.Fragment>
      <Dialog
        fullScreen={isMobile}
        open={showGuidedModeDialog}
        sx={{ zIndex: 10000 }}
        scroll="paper"
        PaperProps={{
          sx: {
            maxHeight: "calc(100vh - 64px)",
            display: "flex",
            flexDirection: "column",
            width: isMobile ? "100%" : "650px",
            maxWidth: isMobile ? "100%" : "650px",
          },
        }}
      >
        <Typography sx={styles.guided.dialogTitle} variant="h6">
          Choose Your Experience
        </Typography>
        <Typography sx={styles.guided.description} variant="body2">
          Select the mode that best fits your needs and experience level.
        </Typography>
        <DialogContent sx={styles.guided.dialogContent(isMobile)} dividers>
          {guidedModeCards.map((data, index) => {
            return (
              <Card sx={styles.guided.card} key={index + "" + data.title}>
                <Typography sx={styles.guided.cardTitle}>
                  {data.title}
                </Typography>
                <Typography sx={styles.guided.cardSubtitle}>
                  {data.description}
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                    marginTop: "10px",
                  }}
                >
                  <Button
                    variant="contained"
                    disableElevation
                    endIcon={<ChevronRightIcon />}
                    sx={styles.guided.submitButton}
                    onClick={() => {
                      handleSwitchChange(data.value);
                      showOrHideGuidedMode(false);
                    }}
                  >
                    {data.btntext}
                  </Button>
                </Box>
              </Card>
            );
          })}
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
}
